import { ArrowRightSlimIcon } from 'icons/ArrowRightSlimIcon';
import { Color } from '@diritto/common/style/color';
import React from 'react';
import { Link } from 'ui-components/common/Link';
import { DescriptionBlock } from 'ui-components/common/DescriptionBlock';
import { MoveIcon } from 'icons/MoveIcon';

export const DirittoStudioBanner = ({ href, onClick }: { href: string; onClick?: () => void }) => (
  <Link href={href} onClick={onClick}>
    <DescriptionBlock
      icon={<MoveIcon color={Color.Primary500} />}
      rightIcon={<ArrowRightSlimIcon size={12} color={Color.Primary500} />}
      message="디리토 스튜디오 가기"
      isBorderRadius={false}
      bgColor={Color.Primary100}
      color={Color.Primary500}
    />
  </Link>
);
